/**
 * Player team statistics calculations
 * Extracts complex team-related calculations from components
 */

import { calculateTeamChemistry } from './teamChemistry';

/**
 * Calculate team statistics for a player with all other players
 * @param {Object} selectedPlayer - The main player
 * @param {Array} players - All players
 * @param {Array} matches - All matches
 * @returns {Array} Array of team stats objects sorted by chemistry
 */
export const calculatePlayerTeamStats = (selectedPlayer, players, matches) => {
  return players
    .filter(p => p.id !== selectedPlayer.id)
    .map(partner => {
      const chemistry = calculateTeamChemistry(
        selectedPlayer,
        partner,
        matches
      );

      const teamMatches = matches.filter(m => {
        const teammates =
          (m.winners.includes(selectedPlayer.id) &&
            m.winners.includes(partner.id)) ||
          (m.losers.includes(selectedPlayer.id) &&
            m.losers.includes(partner.id));
        return teammates;
      });

      const teamWins = teamMatches.filter(m =>
        m.winners.includes(selectedPlayer.id)
      ).length;

      const winRate =
        teamMatches.length > 0
          ? ((teamWins / teamMatches.length) * 100).toFixed(0)
          : 'N/A';

      return {
        partner,
        chemistry,
        teamMatches,
        teamWins,
        teamLosses: teamMatches.length - teamWins,
        winRate,
      };
    })
    .sort((a, b) => b.chemistry - a.chemistry);
};
